export default __webpack_public_path__ + "static/media/Isologo@2x.68931fa6.png";